import type { ProductImageEntry } from "./types";

/** Native client and employee projections for the completed S1 DEV solution. */
export const RESOURCE_SOLUTION_DETAIL_CATALOGUE: readonly ProductImageEntry[] =
  [
    {
      id: "standing-data.client-solution-projection",
      module: "Klientens lösningsprojektion",
      area: "standing-data",
      opens: "Resurser → klient → Schema",
      setup: [
        "Öppna klienten som har minst tre tilldelade besök i den valda S1-lösningen",
        "Välj den matchande lösningsraden i schemarutnätet",
      ],
      scenario: "S1",
      visual: { variant: 0, focus: "projection-timeline" },
      text: {
        sv: {
          alt: "Klientens besök i en vald sparad lösning",
          shows:
            "Projektionen visar klientens schemalagda besök från den valda lösningen.",
          proves:
            "Klientens resursvy kan visa besök från en sparad lösning i sitt sammanhang.",
        },
        en: {
          alt: "A client's visits in a selected saved solution",
          shows:
            "The projection shows the client's scheduled visits from the selected solution.",
          proves:
            "The client resource view can show visits from a saved solution in context.",
        },
      },
      use: ["pages/Plattform.tsx"],
    },
    {
      id: "standing-data.client-assignment-detail",
      module: "Klientens besöksdetaljer",
      area: "standing-data",
      opens: "Resurser → klient → Schema → Besök för vald lösning",
      setup: [
        "Välj den sparade S1-lösning som visas för klienten",
        "Öppna Besök för vald lösning och visa minst tre schemalagda besök",
      ],
      scenario: "S1",
      visual: { variant: 0, focus: "assignment-details" },
      text: {
        sv: {
          alt: "Klientens besökstider och medarbetare i vald lösning",
          shows:
            "Besökstabellen visar planerade tider och tilldelade medarbetare för den valda lösningen.",
          proves:
            "En granskare kan läsa klientens faktiska tilldelningar från den sparade lösningen.",
        },
        en: {
          alt: "A client's visit times and employees in the selected solution",
          shows:
            "The visit table shows planned times and assigned employees for the selected solution.",
          proves:
            "A reviewer can read the client's assignments from the saved solution.",
        },
      },
      use: ["pages/Plattform.tsx"],
    },
    {
      id: "standing-data.employee-solution-projection",
      module: "Medarbetarens lösningsprojektion",
      area: "standing-data",
      opens: "Resurser → medarbetare → Schema",
      setup: [
        "Öppna en medarbetare med minst fem tilldelade besök över två dagar i S1-lösningen",
        "Välj den matchande lösningsraden i schemarutnätet",
      ],
      scenario: "S1",
      visual: { variant: 0, focus: "projection-timeline" },
      text: {
        sv: {
          alt: "Medarbetarens besök i en vald sparad lösning",
          shows:
            "Projektionen visar medarbetarens schemalagda besök från den valda lösningen.",
          proves:
            "Medarbetarvyn kan visa tilldelningar från en sparad lösning över flera dagar.",
        },
        en: {
          alt: "An employee's visits in a selected saved solution",
          shows:
            "The projection shows the employee's scheduled visits from the selected solution.",
          proves:
            "The employee view can show assignments from a saved solution across multiple days.",
        },
      },
      use: ["pages/Plattform.tsx"],
    },
  ];
